import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { ComingSoon } from "../live_sessions";

// Teacher side of the parked live-sessions feature — see pages/live_sessions.
// The route stays mounted so links don't 404, but nothing is fetched and the
// "Schedule a session" form is gone: a teacher must not be able to create a
// session students can't yet see.
//
// The previous implementation (schedule/list/attendees/delete) is in git
// history; restore it here when the feature is ready to ship.
const TeacherLiveSessions = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 font-montserrat">
            <nav className="bg-[#2148C0] shadow-md px-4 sm:px-6 py-4 flex items-center gap-4">
                <button onClick={() => navigate("/teacher-dashboard")} className="text-white shrink-0" aria-label="Back to dashboard">
                    <FaArrowLeft size={18} />
                </button>
                <h1 className="text-lg sm:text-xl font-bold text-white">Live Sessions</h1>
            </nav>

            <ComingSoon
                message="Scheduling live classes for your students is on the way. You'll be able to set a time, share a meeting link and see who's attending — all from here."
                onBack={() => navigate("/teacher-dashboard")}
            />
        </div>
    );
};

export default TeacherLiveSessions;
